import type { FC } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { Box, Button, Card, Container, Typography } from '@material-ui/core';
import Splash from '../global/Splash';
import { showLogin, hideLogin } from '../../store/actions/auth';
import UserIcon from '../icons/User';

const LoginLayout: FC<any> = ({
  isAuthenticated,
  loading,
  showLogin: onShowLogin,
  isShowLogin,
}) => (
  <>
    {isAuthenticated && <Navigate to="/admin" />}
    {!isAuthenticated && (
      <>
        <Helmet>
          <title>Kontigo</title>
        </Helmet>
        {loading && <Splash open={loading} />}
        <Box
          sx={{
            backgroundColor: 'background.default',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundImage: 'url(/static/images/fondo.png)',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Container maxWidth="sm" sx={{ py: '80px' }}>
            <Box
              position="fixed"
              left="0"
              top="0"
              alignItems="center"
              justifyContent="left"
              display="flex"
              alignContent="center"
              width="100%"
              bgcolor="#087bf6"
              padding="12px"
            >
              <Box display="flex" alignContent="start" width="100%">
                <Box flexGrow={1}>
                  <img src="/static/images/kontigo.png" alt="logo" width="80px" />
                </Box>
                <Box>
                  <Button
                    style={{ color: 'white', flex: 1 }}
                    onClick={() => onShowLogin()}
                  >
                    <UserIcon />
                    Ingresar
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 8,
              }}
            />
            {!isShowLogin && (
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                paddingTop={25}
              >
                <Typography color="white" gutterBottom variant="h3">
                  Dashboard
                </Typography>
              </Box>
            )}
            {isShowLogin && (
              <Card>
                <Outlet />
              </Card>
            )}
          </Container>
          <Box
            position="fixed"
            bottom="0"
            alignItems="center"
            justifyContent="center"
            display="flex"
            alignContent="center"
            width="100%"
            bgcolor="#087bf6"
            padding="14px"
          >
            <img src="/static/images/kontigo.png" alt="logo" width="80px" />
          </Box>
        </Box>
      </>
    )}
  </>
);

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
  isShowLogin: state.auth.showLogin,
});

export default connect(mapStateToProps, {
  showLogin,
  hideLogin,
})(LoginLayout);
